/**
 * @generated SignedSource<<8b9ffca1ca20fae2e2f1f73b0c5cbc4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Currency = "BRL" | "USD" | "%future added value";
export type ProjectStatus = "archived" | "completed" | "in_progress" | "%future added value";
export type ProjectsPageQuery$variables = Record<PropertyKey, never>;
export type ProjectsPageQuery$data = {
  readonly projects: ReadonlyArray<{
    readonly color: string | null | undefined;
    readonly currency: Currency;
    readonly hourlyRate: number;
    readonly id: string;
    readonly name: string;
    readonly status: ProjectStatus;
  }>;
};
export type ProjectsPageQuery = {
  response: ProjectsPageQuery$data;
  variables: ProjectsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Project",
    "kind": "LinkedField",
    "name": "projects",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hourlyRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectsPageQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProjectsPageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "467e5cc099823aa69e8390e9d73bc906",
    "id": null,
    "metadata": {},
    "name": "ProjectsPageQuery",
    "operationKind": "query",
    "text": "query ProjectsPageQuery {\n  projects {\n    id\n    name\n    hourlyRate\n    currency\n    status\n    color\n  }\n}\n"
  }
};
})();

(node as any).hash = "3e5db24a5c5c43c32a4dd7e98a6dca9b";

export default node;
